import { InventoryDevice, PropertyPanelDevice } from '@shure/cloud/shared/models/devices';

import { AnalyticsCommonDeviceInfo } from './models/common.model';

export function propertyPanelDeviceToAnalyticsDevice(devices: PropertyPanelDevice[]): AnalyticsCommonDeviceInfo[] {
	return devices.map((device) => ({
		model: device.model,
		serial: device.features.serialNumber?.serialNumber,
		mac: device.features.audioNetwork?.macAddress,
		// eslint-disable-next-line @typescript-eslint/naming-convention
		hardware_id: device.hardwareId,
		// eslint-disable-next-line @typescript-eslint/naming-convention
		network_status: device.status
	}));
}

export function inventoryDeviceToAnalyticsDevice(devices: InventoryDevice[]): AnalyticsCommonDeviceInfo[] {
	return devices.map((device) => ({
		model: device.model,
		serial: device.features.serialNumber?.serialNumber,
		mac: device.features.audioNetwork?.macAddress,
		// eslint-disable-next-line @typescript-eslint/naming-convention
		hardware_id: device.hardwareId,
		// eslint-disable-next-line @typescript-eslint/naming-convention
		network_status: device.status
	}));
}
